import { FetchPolicy } from '@bingads-webui-react/overreact';
import { getDefaultHeaderObj } from '@bingads-webui/overreact-bingads';

export const networkPolicy = FetchPolicy.StoreOrNetwork;

export function headerDecorator(fn) {
  function decorator() {
    return getDefaultHeaderObj();
  }

  return params => decorator(params, fn(params));
}

export const sideEffects = {
  fetch: null,
  refetch: null,
  mutation: null,
  pagination: null,
  add: null,
  destroy: null,
};
